import { gql } from "@apollo/client"

export const GET_REPORT_VERSIONS = gql`
  query GetReportVersions($reportId: ID!) {
    getReportVersions(reportId: $reportId) {
      id
      reportId
      versionNumber
      version
      createdAt
      createdBy {
        id
        displayName
        email
      }
      versionComment
      status
    }
  }
`

export const CREATE_REPORT_VERSION = gql`
  mutation CreateReportVersion($reportId: ID!, $versionComment: String) {
    createReportVersion(reportId: $reportId, versionComment: $versionComment)
  }
`

export const RESTORE_REPORT_VERSION = gql`
  mutation RestoreReportVersion($reportId: ID!, $versionId: ID!) {
    restoreReportVersion(reportId: $reportId, versionId: $versionId)
  }
`

export const GET_REPORT_VERSION = gql`
  query GetReportVersion($reportId: ID!, $versionId: ID!) {
    getReportVersion(reportId: $reportId, versionId: $versionId) {
      id
      name
      reportURL
      title
      info
      status
      tester {
        id
        firstName
        lastName
        email
      }
      version
      versionNumber
      isLatestVersion
      parentVersionId
      createdAt
      createdBy {
        id
        displayName
        email
      }
      versionComment
      examinations {
        id
        name
      }
      chapter {
        id
        name
        chapterNumber
        type
      }
      documentNo
      projectID
    }
  }
`